export class EmailReferenceParameterDto {
    emailCacheId: number;
    emailAccount: string;
    folder: string;
}
